/**
 * Module errors.
 *
 * @module
 */
export const EAGGREGATOR_OVERFLOW = {
  code: 1,
  name: "EAGGREGATOR_OVERFLOW",
} as const;

export const EAGGREGATOR_UNDERFLOW = {
  code: 2,
  name: "EAGGREGATOR_UNDERFLOW",
} as const;
